import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Anuncio = ({ anuncio }) => {

    const { mensaje, fechaPublicacion } = anuncio

    return (
        <div className="anuncio-texto">

            <span className="anuncio-fecha-chip">
                <FontAwesomeIcon icon="clock" />
                Publicado el {fechaPublicacion.stringValue}
            </span>

            <div
                dangerouslySetInnerHTML={{
                    __html: mensaje.stringValue
                }}></div>
        </div>
    )
}

export default Anuncio
